<template>
  <el-menu
    :default-active="$route.path"
    class="menu"
    background-color="#2d3a4b"
    text-color="#fff"
    active-text-color="#409eff"
    :collapse="isCollapse"
    @select="handleSelect"
  >
    <template v-for="menu in menus">
      <el-menu-item v-if="!menu.children.length" :key="menu.id" :index="menu.path">
        <svg :class="$style.icon" class="zp-icon" aria-hidden="true">
          <use :xlink:href="menu.icon" />
        </svg>
        <span slot="title">{{ menu.name }}</span>
      </el-menu-item>
      <el-submenu v-else :key="menu.id" :index="menu.path">
        <template slot="title">
          <svg :class="$style.icon" class="zp-icon" aria-hidden="true">
            <use :xlink:href="menu.icon" />
          </svg>
          <span slot="title">{{ menu.name }}</span>
        </template>
        <el-menu-item v-for="subMenu in menu.children" :key="subMenu.id" :index="`${menu.path}/${subMenu.path}`">
          {{ subMenu.name }}
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import storeUi from '@/store/modules/ui';
import storePermission from '@/store/modules/permission';

export default {
  name: 'MainNav',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(storeUi.name, {
      isCollapse: 'showSidebar',
    }),
    ...mapGetters(storePermission.name, ['menus']),
  },
  methods: {
    handleSelect(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="less" module>
@import '~@/styles/vars.less';

.icon {
  width: 24px;
  margin-right: 5px;
  font-size: 20px;
  vertical-align: middle;
}

:global {
  .menu {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .menu:not(.el-menu--collapse) {
    width: 200px;
    border-right: 0;
  }

  .el-menu-item.is-active {
    background-color: rgb(36, 46, 60) !important;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }

  .el-submenu .el-menu-item,
  .el-menu--popup > .el-menu-item {
    height: 40px;
    line-height: 40px;
  }

  .el-submenu__icon-arrow {
    font-size: 16px;
  }

  .el-menu--vertical {
    max-width: 160px;
    overflow: hidden;
  }
}
</style>
